import { apiPost } from '@/features/shared/utils/dataFetching'
import {
  type TimeslotsV3APIResponse,
  type RetailerETARequestParams,
  type RetailerETAResponse,
} from '@/features/shop/services/DeliveryWindows/types'
import { type TimeslotsQueryKey } from '@/features/shop/services/DeliveryWindows/queries'
import { type QueryFunctionContext } from '@tanstack/react-query'

export const fetchTimeslots = async (context: QueryFunctionContext<TimeslotsQueryKey>) => {
  const [, { apiVersion, ...data }] = context.queryKey

  return apiPost<TimeslotsV3APIResponse>({
    config: {
      url: `/member-web-bff/${apiVersion}/timeslots`,
      data,
    },
    options: {
      ignoredMessages: [/not authorized for alcohol/],
    },
    context,
    fetcherName: 'fetchTimeslots',
  })
}

export const fetchRetailerETAs = async (
  context: QueryFunctionContext<readonly [string, RetailerETARequestParams]>,
) => {
  const [, data] = context.queryKey
  return apiPost<RetailerETAResponse>({
    config: {
      url: '/member-web-bff/v1/retailer-etas',
      data: { ...data, order_type: 'marketplace', promise_type: ['all'] },
    },
    context,
    options: { ignoredMessages: ['not found, all providers failed'] },
    fetcherName: 'fetchRetailerETAs',
  })
}
